module.exports = __webpack_public_path__ + "media/src/web/images/logo-whitebg-011c3cef898a709cddda7e631c992c64.png";